var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1148 16.0001C30.1148 8.64008 24.1415 2.66675 16.7815 2.66675C9.42145 2.66675 3.44812 8.64008 3.44812 16.0001C3.44812 22.4534 8.03479 27.8267 14.1148 29.0667V20.0001H11.4481V16.0001H14.1148V12.6667C14.1148 10.0934 16.2081 8.00008 18.7815 8.00008H22.1148V12.0001H19.4481C18.7148 12.0001 18.1148 12.6001 18.1148 13.3334V16.0001H22.1148V20.0001H18.1148V29.2668C24.8481 28.6001 30.1148 22.9201 30.1148 16.0001Z",
    fill: "#001BCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIc);
export default __webpack_public_path__ + "static/media/fb-ic.1d1dc0eb93c696e716a1f6f0cb534d45.svg";
export { ForwardRef as ReactComponent };